export const getLocation = () => window.location;
